import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ErrorCardModule} from "../../../../components/common/error-card/error-card.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {ViewByIdDefaultComponent} from "./view-by-id-default.component";
import {ViewByAttributeModule} from "../view-by-attribute/view-by-attribute.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ErrorCardModule,
        LoadingModule,
        ViewByAttributeModule,
    ],
    declarations: [
        ViewByIdDefaultComponent,
    ],
    exports: [ViewByIdDefaultComponent]
})
export class ViewByIdDefaultModule {
}